var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal2",
    {
      class: { xlarge: true },
      attrs: {
        id: "awaiting-message-details",
        title: "Talep Detay / " + _vm.getTicketPlatform(),
        "show-footer": false,
      },
      on: { cancel: _vm.closeModal },
    },
    [
      _c(
        "div",
        { staticClass: "tabMenu" },
        _vm._l(_vm.tabs, function (tab, index) {
          return _c(
            "button",
            {
              key: index,
              class: { active: _vm.activeTab === index },
              on: {
                click: function ($event) {
                  _vm.activeTab = index
                },
              },
            },
            [_vm._v("\n            " + _vm._s(tab.name) + "\n        ")]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.activeTab === 0
        ? _c(
            "div",
            [
              _vm.ticket.returnType
                ? _c("div", { staticClass: "information-banner" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("info"),
                    ]),
                    _vm._v(" "),
                    _vm.ticket.returnType === "email" || !_vm.ticket.returnType
                      ? _c("span", [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("ticket.thisPersonEmailAnswered")) +
                              "\n        "
                          ),
                        ])
                      : _vm.ticket.returnType === "whatsapp"
                      ? _c("span", [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("ticket.thisPersonWpAnswered")) +
                              "\n            "
                          ),
                          _c(
                            "a",
                            {
                              attrs: { href: "javascript:void(0)" },
                              on: { click: _vm.showWhatsappChatStarter },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("ticket.clickStartWpChat"))
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "ticket-status-wrapper" },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("span", { staticClass: "status-title" }, [
                        _vm._v(_vm._s(_vm.$t("ticket.requestProgress"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a-tooltip",
                        { attrs: { title: _vm.$t("message.ticketOnlyMail") } },
                        [
                          _c(
                            "i",
                            { staticClass: "material-icons warning-icon" },
                            [_vm._v("info")]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("TicketStatusSwitcher", {
                    attrs: {
                      currentStatus: _vm.ticket.status,
                      statusList: _vm.statusList,
                    },
                    on: {
                      "update-status": function (status) {
                        return _vm.changeTicketStatus(_vm.ticket._id, status)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "user-info-profile",
                  on: { click: _vm.viewContactProfile },
                },
                [
                  _c(
                    "div",
                    { staticClass: "profile-header" },
                    [
                      _vm.isVisitorExist()
                        ? _c("ContactAvatar", {
                            key: _vm.$_.get(
                              _vm.ticket.visitor,
                              "_id",
                              "unknown"
                            ),
                            attrs: {
                              contact: _vm.ticket.visitor,
                              badge: true,
                              "badge-type": "visitor-offline",
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "contact-profile-info" }, [
                        _c("div", { staticClass: "contact-profile-fullname" }, [
                          _vm._v(_vm._s(_vm.visitorInfo.fullname)),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "platform-info" }, [
                          _c("div", { staticClass: "platform-name" }, [
                            _c(
                              "div",
                              { staticClass: "platform-icon-wrapper" },
                              [
                                _vm.$_.get(_vm.ticket.visitor, "platform") ===
                                "whatsapp"
                                  ? _c("WhatsappIcon", {
                                      staticClass: "option-icon",
                                      attrs: { color: "#25D366" },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.$_.get(_vm.ticket.visitor, "platform") ===
                                "telegram"
                                  ? _c("TelegramIcon", {
                                      staticClass: "option-icon",
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.$_.get(_vm.ticket.visitor, "platform") ===
                                "messenger"
                                  ? _c("MessengerIcon", {
                                      staticClass: "option-icon",
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.$_.get(_vm.ticket.visitor, "platform") ===
                                "web"
                                  ? _c("webIcon", {
                                      staticClass: "option-icon",
                                      attrs: { color: "black;" },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.$_.get(_vm.ticket.visitor, "platform") ===
                                "email"
                                  ? _c("mailIcon", {
                                      staticClass: "option-icon",
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.$_.get(_vm.ticket.visitor, "platform") ===
                                "meta-leads"
                                  ? _c("MetaIcon", {
                                      staticClass: "option-icon",
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.$_.get(_vm.ticket.visitor, "platform") ===
                                "instagram"
                                  ? _c("InstagramIcon", {
                                      staticClass: "option-icon",
                                      attrs: { "special-background-mode": "" },
                                    })
                                  : _vm._e(),
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.getPlatformName()) +
                                    "\n                            "
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "value-item" }, [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("email"),
                              ]),
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.getEmailAddress() || "-") +
                                  "\n                            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "value-item",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.showStartChat.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("phone"),
                                ]),
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.getPhoneNumber() || "-") +
                                    "\n                            "
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.$_.get(_vm.ticket.visitor, "platform") ===
                          "whatsapp"
                            ? _c(
                                "div",
                                {
                                  staticClass: "whatsapp-number",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      _vm.showWhatsappChatStarterModal = true
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "a",
                                    { attrs: { href: "javascript:void(0)" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$_.get(
                                            _vm.ticket.visitor,
                                            "whatsappNumber"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.selectedHistory.type === "osr"
                ? _c(
                    "div",
                    [
                      _c("div", { staticClass: "ticket-message" }, [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.$t("ticket.requestMessage"))),
                        ]),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(_vm.selectedHistory.messages))]),
                      ]),
                      _vm._v(" "),
                      !_vm.ticket.resolved
                        ? _c(
                            "div",
                            [
                              _c("quill-editor", {
                                attrs: { options: _vm.editorOption },
                                model: {
                                  value: _vm.responseText,
                                  callback: function ($$v) {
                                    _vm.responseText = $$v
                                  },
                                  expression: "responseText",
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "email-sender-info" }, [
                                _c("p", { staticClass: "email-info-text" }, [
                                  _vm._v(
                                    "Bu e-posta üzerinden ticket gönderilecek"
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "a-select",
                                {
                                  staticStyle: { width: "100%" },
                                  model: {
                                    value: _vm.selectedSenderMailId,
                                    callback: function ($$v) {
                                      _vm.selectedSenderMailId = $$v
                                    },
                                    expression: "selectedSenderMailId",
                                  },
                                },
                                _vm._l(_vm.senderMails, function (senderMail) {
                                  return _c(
                                    "a-select-option",
                                    {
                                      key: senderMail.mail,
                                      attrs: { value: senderMail._id },
                                    },
                                    [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(senderMail.mail) +
                                          "\n                    "
                                      ),
                                    ]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.ticket.resolved
                        ? _c(
                            "b-row",
                            { staticClass: "mt-4" },
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "12" } },
                                [
                                  _vm.ticket.type === "offline"
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            position: "absolute",
                                            right: "42%",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "action-button-tickets",
                                              on: {
                                                click: function ($event) {
                                                  _vm.aiCopilot = {
                                                    type: "fix-grammar",
                                                  }
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "material-icons",
                                                },
                                                [_vm._v("auto_fix_high")]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isSupsisMail()
                                    ? _c(
                                        "div",
                                        { staticClass: "mail-warning" },
                                        [
                                          _c("div", { staticClass: "text" }, [
                                            _vm._v(
                                              "\n                            " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "ticket.withEmailWillNotRecievice"
                                                  )
                                                ) +
                                                "\n                        "
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "link",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.$router.replace(
                                                    "/integrations/mail"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                            " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "ticket.clickAddMailAddress"
                                                    )
                                                  ) +
                                                  "\n                        "
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "SupsisButton",
                                    {
                                      staticClass: "float-right",
                                      attrs: { ghost: "" },
                                      on: { click: _vm.closeModal },
                                    },
                                    [
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(_vm.$t("message.cancel")) +
                                            "\n                        "
                                        ),
                                      ],
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "SupsisButton",
                                    {
                                      staticClass: "float-right mr-2",
                                      attrs: {
                                        primary: "",
                                        disabled: _vm.responseSending,
                                      },
                                      on: { click: _vm.sendResponseAndClose },
                                    },
                                    [
                                      !_vm.responseSending
                                        ? [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "ticket.sendReplyCloseTicket"
                                                )
                                              )
                                            ),
                                          ]
                                        : [
                                            _c("font-awesome-icon", {
                                              attrs: {
                                                icon: "spinner",
                                                spin: "",
                                              },
                                            }),
                                            _vm._v(
                                              "\n                            " +
                                                _vm._s(
                                                  _vm.$t("message.sending")
                                                ) +
                                                "...\n                        "
                                            ),
                                          ],
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "SupsisButton",
                                    {
                                      staticClass: "float-right mr-2",
                                      attrs: {
                                        warning: "",
                                        disabled: _vm.responseSending,
                                        ghost: "",
                                      },
                                      on: { click: _vm.closeTicket },
                                    },
                                    [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(_vm.$t("ticket.closeTicket")) +
                                          "\n                    "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm.selectedHistory.type === "automation"
                ? _c(
                    "div",
                    [
                      _c("div", { staticClass: "ticket-message" }, [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.$t("ticket.requestMessage"))),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            _vm._s(_vm.selectedHistory.ticket.ticketMessage)
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      !_vm.ticket.resolved
                        ? _c(
                            "div",
                            [
                              _c("quill-editor", {
                                attrs: { options: _vm.editorOption },
                                model: {
                                  value: _vm.responseText,
                                  callback: function ($$v) {
                                    _vm.responseText = $$v
                                  },
                                  expression: "responseText",
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "email-sender-info" }, [
                                _c("p", { staticClass: "email-info-text" }, [
                                  _vm._v(
                                    "Bu e-posta üzerinden ticket gönderilecek"
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "a-select",
                                {
                                  staticStyle: { width: "100%" },
                                  model: {
                                    value: _vm.selectedSenderMailId,
                                    callback: function ($$v) {
                                      _vm.selectedSenderMailId = $$v
                                    },
                                    expression: "selectedSenderMailId",
                                  },
                                },
                                _vm._l(_vm.senderMails, function (senderMail) {
                                  return _c(
                                    "a-select-option",
                                    {
                                      key: senderMail.mail,
                                      attrs: { value: senderMail._id },
                                    },
                                    [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(senderMail.mail) +
                                          "\n                    "
                                      ),
                                    ]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "mt-4" },
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "12" } },
                            [
                              _vm.isSupsisMail()
                                ? _c("div", { staticClass: "mail-warning" }, [
                                    _c("div", { staticClass: "text" }, [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm.$t(
                                              "ticket.withEmailWillNotRecievice"
                                            )
                                          ) +
                                          "\n                        "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "link",
                                        on: {
                                          click: function ($event) {
                                            return _vm.$router.replace(
                                              "/integrations/mail"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.$t(
                                                "ticket.clickAddMailAddress"
                                              )
                                            ) +
                                            "\n                        "
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "SupsisButton",
                                {
                                  staticClass: "float-right",
                                  attrs: { ghost: "" },
                                  on: { click: _vm.closeModal },
                                },
                                [
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.$t("message.cancel")) +
                                        "\n                        "
                                    ),
                                  ],
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "SupsisButton",
                                {
                                  staticClass: "float-right mr-2",
                                  attrs: {
                                    primary: "",
                                    disabled: _vm.responseSending,
                                  },
                                  on: { click: _vm.sendResponseAndClose },
                                },
                                [
                                  !_vm.responseSending
                                    ? [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "ticket.sendReplyCloseTicket"
                                              )
                                            )
                                        ),
                                      ]
                                    : [
                                        _c("font-awesome-icon", {
                                          attrs: { icon: "spinner", spin: "" },
                                        }),
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(_vm.$t("message.sending")) +
                                            "...\n                        "
                                        ),
                                      ],
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "SupsisButton",
                                {
                                  staticClass: "float-right mr-2",
                                  attrs: {
                                    warning: "",
                                    disabled: _vm.responseSending,
                                    ghost: "",
                                  },
                                  on: { click: _vm.closeTicket },
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.$t("ticket.closeTicket")) +
                                      "\n                    "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _c("div", [
                    _vm.ticket.type !== "form"
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "flex-direction": "column",
                            },
                          },
                          [
                            _vm.filteredMessages.length
                              ? _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "chat-scroll",
                                        rawName: "v-chat-scroll",
                                      },
                                    ],
                                    staticClass: "waiting-ticket-messages",
                                  },
                                  [
                                    _c("MessageList", {
                                      attrs: {
                                        contextMenuVisable: false,
                                        "always-scroll-to-bottom": false,
                                        colors: _vm.colors,
                                        messages: _vm.getMessages(),
                                        participants: _vm.getParticipants(),
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.ticket.resolved
                              ? _c(
                                  "div",
                                  [
                                    _c("quill-editor", {
                                      attrs: { options: _vm.editorOption },
                                      model: {
                                        value: _vm.responseText,
                                        callback: function ($$v) {
                                          _vm.responseText = $$v
                                        },
                                        expression: "responseText",
                                      },
                                    }),
                                    _vm._v(" "),
                                    ![
                                      "instagram-comment",
                                      "instagram-mention",
                                      "page-comment",
                                      "trendyol",
                                    ].includes(_vm.ticket.type)
                                      ? _c(
                                          "div",
                                          { staticClass: "email-sender-info" },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "email-info-text",
                                              },
                                              [
                                                _vm._v(
                                                  "Bu e-posta üzerinden ticket gönderilecek"
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    ![
                                      "instagram-comment",
                                      "instagram-mention",
                                      "page-comment",
                                      "trendyol",
                                    ].includes(_vm.ticket.type)
                                      ? _c(
                                          "a-select",
                                          {
                                            model: {
                                              value: _vm.selectedSenderMailId,
                                              callback: function ($$v) {
                                                _vm.selectedSenderMailId = $$v
                                              },
                                              expression:
                                                "selectedSenderMailId",
                                            },
                                          },
                                          _vm._l(
                                            _vm.senderMails,
                                            function (senderMail) {
                                              return _c(
                                                "a-select-option",
                                                {
                                                  key: senderMail.mail,
                                                  attrs: {
                                                    value: senderMail._id,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                            " +
                                                      _vm._s(senderMail.mail) +
                                                      "\n                        "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.ticket.resolved
                              ? _c("div", [
                                  _c(
                                    "div",
                                    { staticClass: "actions" },
                                    [
                                      ["instagram-comment"].includes(
                                        _vm.ticket.type
                                      )
                                        ? _c("a-switch", {
                                            attrs: {
                                              name: "hidden",
                                              "checked-children":
                                                "Hidden Comment",
                                              "un-checked-children":
                                                "Unhidden Comment",
                                            },
                                            model: {
                                              value: _vm.hidden,
                                              callback: function ($$v) {
                                                _vm.hidden = $$v
                                              },
                                              expression: "hidden",
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "actions" },
                                    [
                                      [
                                        "instagram-comment",
                                        "instagram-mention",
                                        "page-comment",
                                        "trendyol",
                                        "chatbot",
                                      ].includes(_vm.ticket.type) ||
                                      !!this.ticket.osrPayload
                                        ? _c("div", [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "action-button-tickets",
                                                on: {
                                                  click: function ($event) {
                                                    _vm.aiCopilot = {
                                                      type: "fix-grammar",
                                                    }
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "material-icons",
                                                  },
                                                  [_vm._v("auto_fix_high")]
                                                ),
                                              ]
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "SupsisButton",
                                        {
                                          attrs: { ghost: "" },
                                          on: { click: _vm.closeModal },
                                        },
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(_vm.$t("message.cancel")) +
                                              "\n                        "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      ![
                                        "instagram-comment",
                                        "instagram-mention",
                                        "page-comment",
                                        "trendyol",
                                      ].includes(_vm.ticket.type)
                                        ? _c(
                                            "SupsisButton",
                                            {
                                              attrs: {
                                                primary: "",
                                                disabled: _vm.responseSending,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.sendResponse(true)
                                                },
                                              },
                                            },
                                            [
                                              _vm.responseSending
                                                ? _c(
                                                    "span",
                                                    [
                                                      _c("font-awesome-icon", {
                                                        attrs: {
                                                          icon: "spinner",
                                                          spin: "",
                                                        },
                                                      }),
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "message.sending"
                                                            )
                                                          ) +
                                                          "...\n                    "
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("message.send")
                                                      )
                                                    ),
                                                  ]),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      ["instagram-comment"].includes(
                                        _vm.ticket.type
                                      )
                                        ? _c(
                                            "SupsisButton",
                                            {
                                              attrs: {
                                                danger: "",
                                                disabled: _vm.responseSending,
                                              },
                                              on: {
                                                click: function () {
                                                  return _vm.deleteComment()
                                                },
                                              },
                                            },
                                            [
                                              _vm.responseSending
                                                ? _c(
                                                    "span",
                                                    [
                                                      _c("font-awesome-icon", {
                                                        attrs: {
                                                          icon: "spinner",
                                                          spin: "",
                                                        },
                                                      }),
                                                      _vm._v(
                                                        "\n                        Deleting...\n                    "
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "ticket.deleteCommentAndClose"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      [
                                        "instagram-comment",
                                        "instagram-mention",
                                        "page-comment",
                                      ].includes(_vm.ticket.type)
                                        ? _c(
                                            "SupsisButton",
                                            {
                                              attrs: {
                                                primary: "",
                                                disabled: _vm.responseSending,
                                              },
                                              on: {
                                                click: function () {
                                                  return _vm.sendAsComment(
                                                    false
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm.responseSending
                                                ? _c(
                                                    "span",
                                                    [
                                                      _c("font-awesome-icon", {
                                                        attrs: {
                                                          icon: "spinner",
                                                          spin: "",
                                                        },
                                                      }),
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "message.sending"
                                                            )
                                                          ) +
                                                          "...\n                    "
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.replyAsAComment"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      [
                                        "instagram-comment",
                                        "page-comment",
                                      ].includes(_vm.ticket.type)
                                        ? _c(
                                            "SupsisButton",
                                            {
                                              attrs: {
                                                primary: "",
                                                disabled: _vm.responseSending,
                                              },
                                              on: {
                                                click: function () {
                                                  return _vm.sendAsComment(true)
                                                },
                                              },
                                            },
                                            [
                                              _vm.responseSending
                                                ? _c(
                                                    "span",
                                                    [
                                                      _c("font-awesome-icon", {
                                                        attrs: {
                                                          icon: "spinner",
                                                          spin: "",
                                                        },
                                                      }),
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "message.sending"
                                                            )
                                                          ) +
                                                          "...\n                    "
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.ReplyAsAPm"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      ["trendyol"].includes(_vm.ticket.type)
                                        ? _c(
                                            "SupsisButton",
                                            {
                                              attrs: {
                                                primary: "",
                                                disabled: _vm.responseSending,
                                              },
                                              on: {
                                                click:
                                                  _vm.replyTrendyolQuestion,
                                              },
                                            },
                                            [
                                              _vm.responseSending
                                                ? _c(
                                                    "span",
                                                    [
                                                      _c("font-awesome-icon", {
                                                        attrs: {
                                                          icon: "spinner",
                                                          spin: "",
                                                        },
                                                      }),
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "message.sending"
                                                            )
                                                          ) +
                                                          "...\n                    "
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "ticket.sendReplyAndClose"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        )
                      : _vm.ticket.type === "form"
                      ? _c("div", [
                          _c(
                            "div",
                            { staticClass: "form-content" },
                            [
                              _c("TicketInboxContents", {
                                attrs: {
                                  submissionId: _vm.ticket.formSubmission,
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          !_vm.ticket.resolved
                            ? _c(
                                "div",
                                [
                                  _c("quill-editor", {
                                    attrs: { options: _vm.editorOption },
                                    model: {
                                      value: _vm.responseText,
                                      callback: function ($$v) {
                                        _vm.responseText = $$v
                                      },
                                      expression: "responseText",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "email-sender-info" },
                                    [
                                      _c(
                                        "p",
                                        { staticClass: "email-info-text" },
                                        [
                                          _vm._v(
                                            "Bu e-posta üzerinden ticket gönderilecek"
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      model: {
                                        value: _vm.selectedSenderMailId,
                                        callback: function ($$v) {
                                          _vm.selectedSenderMailId = $$v
                                        },
                                        expression: "selectedSenderMailId",
                                      },
                                    },
                                    _vm._l(
                                      _vm.senderMails,
                                      function (senderMail) {
                                        return _c(
                                          "a-select-option",
                                          {
                                            key: senderMail.mail,
                                            attrs: { value: senderMail._id },
                                          },
                                          [
                                            _vm._v(
                                              "\n                            " +
                                                _vm._s(senderMail.mail) +
                                                "\n                        "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    { staticClass: "mt-4" },
                                    [
                                      _c(
                                        "b-col",
                                        { attrs: { md: "12" } },
                                        [
                                          _vm.isSupsisMail()
                                            ? _c(
                                                "div",
                                                { staticClass: "mail-warning" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "text" },
                                                    [
                                                      _vm._v(
                                                        "\n                                    " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "ticket.withEmailWillNotRecievice"
                                                            )
                                                          ) +
                                                          "\n                                "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "link",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.$router.replace(
                                                            "/integrations/mail"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                    " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "ticket.clickAddMailAddress"
                                                            )
                                                          ) +
                                                          "\n                                "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "SupsisButton",
                                            {
                                              staticClass: "float-right",
                                              attrs: { ghost: "" },
                                              on: { click: _vm.closeModal },
                                            },
                                            [
                                              [
                                                _vm._v(
                                                  "\n                                    " +
                                                    _vm._s(
                                                      _vm.$t("message.cancel")
                                                    ) +
                                                    "\n                                "
                                                ),
                                              ],
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "SupsisButton",
                                            {
                                              staticClass: "float-right mr-2",
                                              attrs: {
                                                primary: "",
                                                disabled: _vm.responseSending,
                                              },
                                              on: {
                                                click: _vm.replyToFormTicket,
                                              },
                                            },
                                            [
                                              !_vm.responseSending
                                                ? [
                                                    _vm._v(
                                                      " Cevap Gönder ve Kapatma\n                                "
                                                    ),
                                                  ]
                                                : [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "spinner",
                                                        spin: "",
                                                      },
                                                    }),
                                                    _vm._v(
                                                      "\n                                    " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "message.sending"
                                                          )
                                                        ) +
                                                        "...\n                                "
                                                    ),
                                                  ],
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "SupsisButton",
                                            {
                                              staticClass: "float-right mr-2",
                                              attrs: {
                                                primary: "",
                                                disabled: _vm.responseSending,
                                              },
                                              on: {
                                                click: _vm.sendResponseAndClose,
                                              },
                                            },
                                            [
                                              !_vm.responseSending
                                                ? [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "ticket.sendReplyCloseTicket"
                                                          )
                                                        ) +
                                                        "\n                                "
                                                    ),
                                                  ]
                                                : [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "spinner",
                                                        spin: "",
                                                      },
                                                    }),
                                                    _vm._v(
                                                      "\n                                    " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "message.sending"
                                                          )
                                                        ) +
                                                        "...\n                                "
                                                    ),
                                                  ],
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "SupsisButton",
                                            {
                                              staticClass: "float-right mr-2",
                                              attrs: {
                                                warning: "",
                                                disabled: _vm.responseSending,
                                                ghost: "",
                                              },
                                              on: { click: _vm.closeTicket },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                " +
                                                  _vm._s(
                                                    _vm.$t("ticket.closeTicket")
                                                  ) +
                                                  "\n                            "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ])
                      : _c(
                          "div",
                          [
                            _c(
                              "b-alert",
                              { attrs: { show: "", variant: "info" } },
                              [_vm._v(_vm._s(_vm.$t("message.chatNotFound")))]
                            ),
                          ],
                          1
                        ),
                  ]),
              _vm._v(" "),
              _vm.showWhatsappChatStarterModal
                ? _c(
                    "Modal2",
                    {
                      attrs: {
                        title: _vm.$t("ticket.startChatWp"),
                        showFooter: false,
                      },
                      on: {
                        cancel: function ($event) {
                          _vm.showWhatsappChatStarterModal = false
                        },
                      },
                    },
                    [
                      _c("WhatsappChatStarter", {
                        attrs: {
                          "default-phone-number": _vm.getPhoneNumber(),
                          "channel-override": "",
                          "phone-number-override": "",
                          "default-email": _vm.$_.get(
                            _vm.ticket.visitor,
                            "email"
                          ),
                          "default-name": _vm.$_.get(
                            _vm.ticket.visitor,
                            "fullname"
                          ),
                        },
                        on: {
                          close: function ($event) {
                            _vm.showWhatsappChatStarterModal = false
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.aiCopilot
                ? _c("AICopilot", {
                    attrs: {
                      type: "ticket",
                      ticketText: _vm.responseText,
                      osrPayload: _vm.ticket.osrPayload,
                      ticketMessage: _vm.ticket.conversation
                        ? _vm.ticket.conversation._id
                        : null,
                    },
                    on: {
                      close: function ($event) {
                        _vm.aiCopilot = null
                      },
                      change: function ($event) {
                        _vm.responseText = $event
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "navigation-buttons" },
                [
                  _c(
                    "SupsisButton",
                    {
                      attrs: { ghost: "" },
                      on: {
                        click: function ($event) {
                          return _vm.navigate(-1)
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "keyboard-shortcut" }, [
                        _vm._v("Ctrl+←"),
                      ]),
                      _vm._v("\n                Önceki\n            "),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "SupsisButton",
                    {
                      attrs: { ghost: "" },
                      on: {
                        click: function ($event) {
                          return _vm.navigate(1)
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "keyboard-shortcut" }, [
                        _vm._v("Ctrl+→"),
                      ]),
                      _vm._v("\n                Sonraki\n            "),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.activeTab === 1
        ? _c(
            "div",
            { staticClass: "responses-container" },
            [
              !_vm.ticket.responses || _vm.ticket.responses.length === 0
                ? [
                    _c("div", { staticClass: "no-responses" }, [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("warning"),
                      ]),
                      _vm._v(
                        "\n                Herhangi bir cevap bulunamadı\n            "
                      ),
                    ]),
                  ]
                : _vm._l(_vm.ticket.responses, function (response) {
                    return _c(
                      "div",
                      { key: response._id, staticClass: "ticket-response" },
                      [
                        _c("div", { staticClass: "response-header" }, [
                          _c(
                            "div",
                            { staticClass: "user" },
                            [
                              _c("AgentAvatar", {
                                attrs: {
                                  userID: response.user._id,
                                  size: 30,
                                  singleChar: "",
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "user-name" }, [
                                _vm._v(_vm._s(response.user.name)),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "response-date" },
                            [
                              response.text.includes("Archived by")
                                ? [
                                    _vm._v(
                                      "\n                            Ticket Bu Tarihte Arşivlendi: " +
                                        _vm._s(
                                          _vm.formatDate(response.answerDate)
                                        ) +
                                        "\n                        "
                                    ),
                                  ]
                                : [
                                    _vm._v(
                                      "\n                            Ticket Şu Tarihte Cevap Verdi: " +
                                        _vm._s(
                                          _vm.formatDate(response.answerDate)
                                        ) +
                                        "\n                        "
                                    ),
                                  ],
                            ],
                            2
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "response-content" }, [
                          _vm._v(
                            "\n                    " +
                              _vm._s(response.text) +
                              "\n                "
                          ),
                        ]),
                      ]
                    )
                  }),
            ],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }